import { BRAND, ZORBA } from "../data/content";

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: BRAND.name,
  url: BRAND.url,
  description: BRAND.description,
  areaServed: {
    "@type": "City",
    name: `${BRAND.city}, ${BRAND.state}, ${BRAND.country}`,
  },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BRAND.name,
  url: BRAND.url,
  inLanguage: "en-IN",
  potentialAction: {
    "@type": "SearchAction",
    target: `${BRAND.url}/spa-services-bhubaneswar/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    item: it.href ? `${BRAND.url}${it.href}` : undefined,
  })),
});

export const daySpaSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "DaySpa",
    name: ZORBA.name,
    url: `${BRAND.url}/zorba-international-spa/`,
    address: {
      "@type": "PostalAddress",
      addressLocality: ZORBA.city,
      addressRegion: ZORBA.state,
      addressCountry: ZORBA.country,
    },
    areaServed: ZORBA.city,
  };
  if (ZORBA.address) schema.address.streetAddress = ZORBA.address;
  if (ZORBA.phone) schema.telephone = ZORBA.phone;
  if (ZORBA.priceRange) schema.priceRange = ZORBA.priceRange;
  if (ZORBA.hours) schema.openingHours = ZORBA.hours;
  if (ZORBA.mapUrl) schema.hasMap = ZORBA.mapUrl;
  return schema;
};

export const serviceSchema = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.name,
  description: service.intro,
  category: "Spa and Wellness",
  areaServed: {
    "@type": "City",
    name: `${BRAND.city}, ${BRAND.state}, ${BRAND.country}`,
  },
  provider: {
    "@type": "DaySpa",
    name: ZORBA.name,
    address: {
      "@type": "PostalAddress",
      addressLocality: ZORBA.city,
      addressRegion: ZORBA.state,
      addressCountry: ZORBA.country,
    },
  },
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const multiGraph = (...nodes) => ({
  "@context": "https://schema.org",
  "@graph": nodes.filter(Boolean),
});
